import { useFormik } from "formik";
import axiosInstance from "../../axiosInterceptor";
import {  paymentSchema } from "../../Schema/Schema";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Upload from "../../Components/upload";
import { SwitchToggle } from "../../helper/ImageFormat";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const AddPaymentMethod = () => {
 const location = useLocation();
  const navigator = useNavigate();
 const editData = location.state;
 const editingId = editData?.id;

 const [loading, setLoading] = useState(false);
 const initialValues = {
  name: "",
  charge: 0,
  description: "",
  image: "",
  isActive: true,
 };

 const {
  errors,
  values,
  handleBlur,
  handleChange,
  handleSubmit,
  setFieldValue,
  touched,
 } = useFormik({
  initialValues,
  validationSchema: paymentSchema,
  onSubmit: async (values, { resetForm }) => {
   setLoading(true);
   try {
    const response = editingId
     ? await axiosInstance.put(`/paymentmethod/${editingId}`, values)
     : await axiosInstance.post("/paymentmethod", values);

    if (response.status === 200) {
        navigator("/payment-method");
     toast.success(response?.data?.message);
    }
   } catch (err) {
    toast.error(err?.response?.data?.message);
   } finally {
    setLoading(false);
   }
  },
 });

 useEffect(() => {
  if (editingId) {
   setFieldValue("name", editData?.name || "");
   setFieldValue("charge", editData?.charge || 0);
   setFieldValue("description", editData?.description || "");
   setFieldValue("image", editData?.image || "");
   setFieldValue("isActive", editData?.isActive ?? true);
  }
 }, [editingId, setFieldValue]);

 return (
  <div className="content-wrapper">
   <div className="page-header mt-5">
    <h3 className="page-title">{editData?.id ? "Update" : "Add"} Payment Method</h3>
   </div>

   <div className="row grid-margin stretch-card">
    <div className="col-md-12">
     <div className="card">
      <div className="card-body">
       <form onSubmit={handleSubmit}>
        <div className="row g-3">
         <div className="col-lg-6 col-md-12">
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Select Payment Method
                    </label>
                    <select
                      className="form-control"
                      id="name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                    >
                      <option value="">Select Payment Method</option>
                      <option value="razorpay">RAZORPAY</option>
                      <option value="bank">BANK</option>
                      <option value="ccAvenue">CC Avenue</option>
                    </select>
                    {touched.name && errors.name && <small className="text-danger">{errors.name}</small>}
                  </div>
                </div>

         <div className="col-lg-6 col-md-12">
          <label className="col-form-label" htmlFor="charge">
           Charge
          </label>
          <input
           type="number"
           name="charge"
           min={0}
           max={100}
           id="charge"
           placeholder="Enter charge (e.g. 2.5%)"
           className="form-control form-control-sm border border-dark"
           value={values.charge}
           onChange={handleChange}
           onBlur={handleBlur}
          />
          {touched.charge && errors.charge && (
           <div className="text-danger">{errors.charge}</div>
          )}
         </div>

         <div className="col-lg-6 col-md-12">
          <label className="col-form-label" htmlFor="description">
           Description
          </label>
          <input
           type="text"
           name="description"
           id="description"
           placeholder="Enter description"
           className="form-control form-control-sm border border-dark"
           value={values.description}
           onChange={handleChange}
           onBlur={handleBlur}
          />
          {touched.description && errors.description && (
           <div className="text-danger">{errors.description}</div>
          )}
         </div>
           

         <div className="col-lg-6 col-md-12 mt-2">
          <label className="form-label fw-bold">Image</label>
          <Upload
           label="payment-method-flag"
           initialImage={values.image}
           onChange={(imgUrl) => setFieldValue("image", imgUrl)}
          apiUrl={"uploads?label=payment"}
          />
         </div>

         <div className="col-md-12 mt-4">
          <SwitchToggle
           checked={values.isActive}
           onChange={(val) => setFieldValue("isActive", val)}
           activeLabel="Active"
           inactiveLabel="Inactive"
          />
         </div>

         <div
          className="col-12 mt-4 d-flex justify-content-center "
          style={{ gap: "15px" }}
         >
          <button type="submit" className="btn btn-primary" disabled={loading}>
           {loading ? "Loading..." : editData?.id ? "Update" : "Add"}
          </button>
          <Link to="/payment-method">
           <button type="button" className="btn btn-danger">
            Cancel
           </button>
          </Link>
         </div>
        </div>
       </form>
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default AddPaymentMethod